export const ALL_CATEGORIES = "Sve kategorije";
export const SPREAD = " | ";
export const COMMA = ", ";